
























import {Component, Vue} from 'vue-property-decorator'
import { callAppRouter } from '../js/tool.js'
import choiceBedRoom from '../components/choiceBedRoom.vue'

@Component({
    components: {
        choiceBedRoom
    },
})
export default class Result extends Vue {
    private changAnimation: boolean = false
    private changAnimation2: boolean = false
    private changAnimation3: boolean = false
    private name: string = ''
    private callApp () {
        // this.$root.share.appShare(this.$root.imgSaver) // this.$root.imgSaver
        // callAppRouter('Share', { 'imgUrl': this.$root.imgSaver, 'shareType': 3 })
    }
    // ts包裹ref选择器
    private _ref (s: string) {
        const ref: any = this.$refs[s]
        return ref
    }
    private mounted () {
        setTimeout(() => {
            this.changAnimation = true
            setTimeout(() => {
                this.changAnimation2 = true
                setTimeout(() => {
                    this.changAnimation3 = true
                    this._ref('bedRoom').toDrawing()
                    this.$parent.showDown = true && !this.$root.cosSleep
                }, 500)
            }, 1000)
        }, 500)
        // this.$root.share.appShare(this.$root.imgSaver)
        this.$parent.opacityMusic = 0
        if (this.$root.configData.type === 'reason') {
            localStorage.removeItem('name')
            localStorage.setItem('result', '1')
            this.name = '啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊' // localStorage.getItem('name') + '啊啊啊啊啊啊'
        }
        if (!this.$root.ghostBed.ghosts) {
            this.$router.replace('./')
        }
        // const share_data = {
        //     type1: {
        //         title: '123',
        //         desc: '123',
        //         link: '123',
        //         imgUrl: 'https://res.psy-1.com/FuEkHrPKqRy5CqZVYUnKPRUnpyAO',
        //         shareType: 1
        //     },
        //     type2: {
        //         title: '123',
        //         link: '123',
        //         imgUrl: 'https://res.psy-1.com/FuEkHrPKqRy5CqZVYUnKPRUnpyAO',
        //         shareType: 2
        //     },
        //     type3: {
        //         imgUrl: 'https://res.psy-1.com/FuEkHrPKqRy5CqZVYUnKPRUnpyAO', // 空出来 不然优先分享图片
        //         shareType: 3
        //     }
        // }
        // document.getElementById('share').value = JSON.stringify(share_data)
        // document.getElementById('share2').value = JSON.stringify(share_data.type1)
        // document.getElementById('share3').value = JSON.stringify(share_data.type2)
    }
}
